import { AlignmentOptions, WidthOptions } from '@types';
import clsx from 'clsx';

import { PageRenderTransition } from '@/lib/server';

import { PageRender } from '../util/page-render';
import { BlockBase, Wrapper, childClassNames, columnsClassName, getMarginClassNames } from './utils';

const columnOptions = {
  1: 'sm:grid-cols-1',
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-3',
  4: 'sm:grid-cols-4',
  5: 'sm:grid-cols-5',
  6: 'sm:grid-cols-6',
  7: 'sm:grid-cols-7',
  8: 'sm:grid-cols-8',
};

export function Columns({
  params,
  contentAlignment,
  transition,
  margin,
  blockWidth,
  ...data
}: {
  maxColumns: number;
  transition?: PageRenderTransition;
  contentAlignment?: AlignmentOptions;
  blockWidth: WidthOptions;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: any[];
} & BlockBase) {
  const maxColumns = columnOptions[data?.maxColumns as keyof typeof columnOptions] || columnOptions[2];

  return (
    <Wrapper
      className={clsx(getMarginClassNames(margin), {
        'max-w-none': blockWidth === 'full',
        'max-w-[theme(screens.3xl)]': blockWidth === 'desktop',
        'max-w-(--breakpoint-2xl)': blockWidth === 'wide' || !blockWidth,
        'max-w-(--breakpoint-xl)': blockWidth === 'standard',
        'max-w-(--breakpoint-lg)': blockWidth === 'narrow',
        'max-w-(--breakpoint-md)': blockWidth === 'prose',
      })}
    >
      <div className={`z-20 grid w-full grid-cols-1 gap-8 ${maxColumns}`}>
        {Array.isArray(data?.columns) &&
          data.columns.map((col, idx) => (
            <div
              key={`column_${idx}`}
              className={clsx(columnsClassName, {
                'items-start text-start':
                  contentAlignment?.alignment?.horizontalAlignment === 'left' ||
                  !contentAlignment?.alignment?.horizontalAlignment,
                'items-center text-center': contentAlignment?.alignment?.horizontalAlignment === 'center',
                'items-end text-end': contentAlignment?.alignment?.horizontalAlignment === 'right',
                'justify-start':
                  contentAlignment?.alignment?.verticalAlignment === 'top' ||
                  !contentAlignment?.alignment?.verticalAlignment,
                'justify-center': contentAlignment?.alignment?.verticalAlignment === 'middle',
                'justify-end': contentAlignment?.alignment?.verticalAlignment === 'bottom',
              })}
            >
              <PageRender
                key={`column_${idx}`}
                params={params}
                transition={
                  transition && {
                    name: transition.name,
                    delay: idx * 0.2,
                    classNames: childClassNames,
                  }
                }
                data={{ contentAlignment, ...col.content }}
              />
            </div>
          ))}
      </div>
    </Wrapper>
  );
}
